import { render } from "./RegistrationFields.vue?vue&type=template&id=df5dde52&ts=true"
import script from "./RegistrationFields.vue?vue&type=script&lang=ts"
export * from "./RegistrationFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__